import { yupResolver } from '@hookform/resolvers/yup';
import classNames from 'classnames';
import React, { useMemo, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form';
import { ROUTES_PATHS } from "../../const";
import { INVALIDATION_TIP } from "../../const/validation";
import { IMaskInput } from 'react-imask';
import * as yup from 'yup';
import { useCountdown, useStores } from '../../hooks';
import { ButtonCustom } from '../ButtonCustom';
import { FormLabel } from '../FormLabel';
import { TextInput } from '../TextInput';

import styles from './styles/fast_registration_form.module.scss';
import inputStyles from '../TextInput/styles/text_input.module.scss';

export const handleChangeMaxLength = (e, maxLength) => {
  e.target.value = e.target.value.slice(0, maxLength);
};

const firstStepSchema = yup.object().shape({
  phone: yup
    .string().nullable().transform((v, o) => (o === '' ? null : v)).matches(/^\d{11}/, INVALIDATION_TIP.INCORRECT_PHONE)
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(/^\d{11}/, INVALIDATION_TIP.INCORRECT_PHONE),
});

const secondStepSchema = yup.object().shape({
  phone: yup
    .string().nullable().transform((v, o) => (o === '' ? null : v))
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(/^\d{11}/, INVALIDATION_TIP.INCORRECT_PHONE),
  code: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(/^\d{4}/, INVALIDATION_TIP.MIN_CODE_LENGTH)
});

const FAST_REG_STEPS = {
  GET_CODE: 1,
  CHECK_CODE: 2
};

export const FastRegistrationForm = ({agreement}) => {
  const [step, setStep] = useState(1);
  const [timerSeconds, setTimerSeconds] = useState(null)

  const { api, modalStore } = useStores();
  const { minutes, seconds, isOver, resetTimer } = useCountdown(timerSeconds);

  const formSchema = useMemo(
    () => (step === 1 ? firstStepSchema : secondStepSchema),
    [step],
  );

  const navigate = useNavigate();

  const {
    control,
    register,
    trigger,
    formState: { errors, isValid },
    reset,
    clearErrors,
    setError,
    handleSubmit,
    watch,
    setFocus
  } = useForm({
    mode: 'all',
    resolver: yupResolver(formSchema),
  });

  const allFildes = watch();

  const getCode = (data) => {
    const reqObj = { ...data, phone: `+${data.phone}` };

    reset({ code: '' }, { keepValues: true });

    api.auth.postFastRegistration(reqObj).then((response) => {
      handleGetCode();
      setTimerSeconds(response.expires_in);
      resetTimer(response.expires_in);
    }).catch((error) => {
      setError('phone', {
        message: error.response.data.phone[0],
      });
    });
  }

  const onSubmit = (data) => {
    const reqObj = { ...data, phone: `+${data.phone}` };

    switch (step) {
      case FAST_REG_STEPS.GET_CODE:
        getCode(data)
        break;

      case FAST_REG_STEPS.CHECK_CODE:
        api.auth.postConfirmPhoneForFastRegistration(reqObj).then((response) => {
          navigate(ROUTES_PATHS.PERSONAL);
        }).catch((error) => {
          setError('code', {
            message: error.response.data.code,
          });
        });
        break;

      default:
        break;
    }
  };

  const resendCode = () => {
    const reqestWatch = { phone: allFildes.phone }
    getCode(reqestWatch)
  };

  const handleGetCode = () => {
    setStep(2);
    clearErrors();
  };

  const lkLoginModal = function () {
    modalStore.open('login');
  };

  return (
    <div className={styles.container}>
      <h1 className="lk-reg-title">Быстрая регистрация</h1>
      <form
        className={styles.fast_registration}
        onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.fast_registration__item}>
          <FormLabel text="Контактный номер телефона" isRequired />
          <Controller
            render={({ field: { onChange, value } }) => (
              <IMaskInput
                className={inputStyles.input}
                mask={'+{7} 000 000-00-00'}
                unmask={true}
                value={value}
                onAccept={(val) => onChange(val)}
                disabled={step !== 1}
                onBlur={() => trigger()}
              />
            )}
            id="phone"
            name="phone"
            type="tel"
            control={control}
          />
          {errors.phone && (
            <span className="error-form-element">{errors.phone?.message}</span>
          )}
        </div>
        {step === 1 && (
          <ButtonCustom
            className={styles.fast_registration__sms_button}
            text="Получить код из SMS"
            type="submit"
            disabled={!isValid}
          />
        )}
        {step === 2 && (
          <>
            <div
              className={classNames({
                [styles.fast_registration__item]: true,
                [styles.fast_registration__item_code]: true,
              })}
            >
              <FormLabel text="Код из SMS" isRequired />
              <Controller
                render={({ field: { onChange, value } }) => (
                  <TextInput
                    type="number"
                    controls={false}
                    onChange={(event) => {
                      handleChangeMaxLength(event, 4)
                      onChange(event)
                    }}
                    step={1}
                  />
                )}
                name="code"
                control={control}
              />

              {!isOver && (
                <span
                  className={styles.fast_registration__action_time}
                >{`Время действия ${minutes}:${seconds}`}</span>
              )}
              {isOver && (
                <button
                  type="button"
                  className={styles.fast_registration__get_new_code}
                  onClick={resendCode}
                >
                  Получить новый код
                </button>
              )}
              {errors.code && (
                <span className="error-form-element">
                  {errors.code?.message}
                </span>
              )}
            </div>
            <ButtonCustom
              className={styles.fast_registration__req_button}
              text="Зарегистрироваться"
              type="submit"
              disabled={!isValid}
            />
          </>
        )}
        <div className={styles.fast_registration__terms}>
          Создавая личный кабинет, я соглашаюсь c <br />
          <span className="total-polite-link">
            <a href={agreement} target="_blank" rel="noreferrer">
              Условиями обработки персональных данных
            </a>
          </span>
        </div>
      </form>
      <button
        id="lk-reg-login-btn"
        className={classNames({
          'lk-reg-form-item-account': true,
          [styles.fast_registration__has_account_btn]: true,
        })}
        onClick={lkLoginModal}
        type="button"
      >
        Уже есть аккаунт?
      </button>
    </div>
  );
};
